<script>
import { httpServices } from '@utils/http-services'

export default {
  props: {
    hardwares: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.id.localeCompare(b.id),
        },
        {
          title: 'Serial',
          dataIndex: 'serial',
          key: 'serial',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.serial.localeCompare(b.serial),
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: {
            customRender: 'customRender',
          },
        },
        {
          title: 'Timezone',
          dataIndex: 'timezone',
          key: 'timezone',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.timezone.localeCompare(b.timezone),
        },
        {
          title: 'Organization',
          dataIndex: 'orgId',
          key: 'orgId',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.orgId.localeCompare(b.orgId),
        },
        {
          title: 'Actions',
          key: 'actions',
          scopedSlots: {
            customRender: 'customRender',
          },
        },
      ],
    }
  },
  methods: {
    onDelete(record) {
      this.$emit('deleteHardware', record)
    },
    viewRow(record) {
      const hardwareId = record.pk.replace('HARDWARE#', '')
      this.$router.push({
        name: 'hardware-summary',
        params: { hardwareId },
      })
    },
    selectRow(record) {
      const hardwareId = record.pk.replace('HARDWARE#', '')
      this.$router.push({
        name: 'hardware-profile',
        params: { hardwareId },
      })
    },
    onReset(record) {
      const hardwareId = record.pk.replace('HARDWARE#', '')
      httpServices.resetHardware(hardwareId).then((_r) => {
        this.$notification.success({
          message: `${hardwareId} device is resetting`,
        })
      })
    },
  },
}
</script>

<template>
  <a-table :data-source="hardwares" :columns="columns">
    <template slot="customRender" slot-scope="text, record, index, column">
      <template>
        <div v-if="column.key === 'id'">
          <a-tag
            :color="record.color"
            style="cursor: pointer"
            @click="() => viewRow(record, column)"
            >{{ text }}
          </a-tag>
        </div>
        <div v-else-if="column.key === 'actions'">
          <ul class="actions">
            <li>
              <a
                href="javascript:;"
                title="Edit Hardware"
                @click="() => selectRow(record, column)"
              >
                <a-button type="primary" icon="edit" size="small"></a-button>
              </a>
            </li>
            <li>
              <a-popconfirm
                title="Sure to delete?"
                @confirm="() => onDelete(record)"
              >
                <a href="javascript:;" title="Delete Hardware">
                  <a-button type="danger" icon="delete" size="small"></a-button>
                </a>
              </a-popconfirm>
            </li>
            <li>
              <a-popconfirm
                title="Sure to reset this hardware?"
                @confirm="() => onReset(record)"
              >
                <a href="javascript:;" title="Reset Hardware">
                  <a-button
                    type="dashed"
                    icon="poweroff"
                    size="small"
                  ></a-button>
                </a>
              </a-popconfirm>
            </li>
          </ul>
        </div>
        <div v-else-if="column.key === 'status'">
          <a-tag :color="text.toLowerCase() === 'online' ? 'green' : 'red'">
            {{ text.toUpperCase() }}
          </a-tag>
        </div>
        <div v-else>{{ text }}</div>
      </template>
    </template>
  </a-table>
</template>

<style scoped>
.highlight {
  padding: 0;
  background-color: rgb(255, 192, 105);
}
</style>
